export default "/static-assets/_next/static/locales/es/common.c13086e6c9a2b1fbdf6c0678795d5edc.json";